module.exports = __webpack_public_path__ + "img/reconnect_icon.06c29542.svg";